import { SortingTypeIndex } from "shared/constants/sortingType";

export const replaceFilterParamForManualTab = (filter: Record<string, any>) => {
    const isCustomSorting = !!filter?.customSorting;
    if (isCustomSorting) {
        return undefined
    }
    else if (filter?.projectFilter === SortingTypeIndex.team_date) {
        return SortingTypeIndex.team_date_for_manual_tab;
    }
    return filter?.projectFilter;
}import { SortingTypeIndex } from "shared/constants/sortingType";

export const replaceFilterParamForManualTab = (filter: Record<string, any>) => {
    const isCustomSorting = !!filter?.customSorting;
    if (isCustomSorting) {
        return undefined
    }
    else if (filter?.projectFilter === SortingTypeIndex.team_date) {
        return SortingTypeIndex.team_date_for_manual_tab;
    }
    return filter?.projectFilter;
}